module.exports = __webpack_public_path__ + "static/media/Arthritis.bb883077.jpg";